<template>
	<div class="cloud-videoMonitoring">
		<div class="cloud-videoMonitoring-l">
			<div class="cloud-videoMonitoring-title">
				<div class="cloud-videoMonitoring-title-title">
					<img src="@/assets/images/groupTitle.png" alt="" style="width: 100%; height: 4vh;" />
					<p>视频监控列表</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '10%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 88%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<div class="cloud-videoMonitoring-title-content">
					<FixedTree :treeData="treeData" @node-click="handleNodeClick" />
				</div>
			</div>
		</div>

		<div class="cloud-videoMonitoring-r">
			<div class="cloud-videoMonitoring-title" style="width: 100%; ">
				<div class="cloud-videoMonitoring-title-title">
					<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
					<p>监控视频</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 96%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<div class="cloud-videoMonitoring-title-content" style="overflow-y: hidden;">
					<ul class="cloud-videoMonitoring-title-content-ul">
						<li><img src="@/assets/images/Frame_10.png"></li>
						<li><img src="@/assets/images/Frame_9.png"></li>
						<li><img src="@/assets/images/Frame_8.png"></li>
						<li><img src="@/assets/images/Frame_7.png"></li>
						<li><img src="@/assets/images/Frame_6.png"></li>
						<li><img src="@/assets/images/Frame_5.png"></li>
						<li><img src="@/assets/images/Frame_4.png"></li>
						<li><img src="@/assets/images/Frame_2.png"></li>
						<li><img src="@/assets/images/Frame_1.png"></li>
					</ul>
					<div>
						<div v-show="isShowHteml === true" id="ezuikit-player"
							style="margin: 0 auto; width: 1280px; height: 680px;"></div>
						<video v-show="isShowHteml === false" ref="videoRef" controls preload="auto"
							style="margin: 0 auto; width: 100%; height: 650px;" muted
							poster="https://example.com/cover.jpg">
							<source src="@/assets/temp/4cc63907172c19ee76903e322a21fb80.mp4" type="video/mp4">
							您的浏览器不支持 HTML5 视频播放，请升级浏览器！
						</video>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FixedTree from '../../components/FixedTree.vue'
import { videoMonitoring, getDataByTreeId, getFileUrlById } from '@/public/api.js'
import EZUIKit from "ezuikit-js";
import axios from 'axios';
import { targetDate } from '@/utils/index.js'
const videoMonitoring1 = ('@/assets/temp/4cc63907172c19ee76903e322a21fb80.mp4')
const videoMonitoring2 = ('@/assets/temp/a5323b5b88ea9210ed5e4634fa0eaf9f.mp4')
const videoMonitoring3 = ('@/assets/temp/346b5c949c7f7824bbbe02d35cbff3bc.mp4')

// 引入路由实例
export default {
	name: 'videoMonitoring',
	components: {
		FixedTree
	},
	data() {
		return {
			treeData: [],
			isShowHteml: window.location.hostname === '39.101.122.159' ? true : false,
			pathSrc: window.location.hostname === '39.101.122.159' ? 'http://' + window.location.hostname + ':19001/prod-api' : 'http://' + window.location.hostname + ':10181/stage-api',
			player: null, // 存储视频播放器实例
			currentVideoSrc: '', // 当前播放的视频源
			form: {
				itemId: '', // 隧道编号
				type: 'videoMonitoring',//类型
				pageNum: 1, // 页码
				pageSize: 10 // 每页显示条数
			},
		}
	},
	computed: {

	},
	mounted() {
		let that = this;
		that.TunnelsData = JSON.parse(localStorage.getItem('updateLhTunnels'));

		that.form.itemId = that.TunnelsData.itemId;

		if (window.location.hostname === 'sd.yongsixinxi.com' || window.location.hostname === '127.0.0.1') {
			that.treeData = [{
				id: 1,
				label: '进口球机画面1',
				url: videoMonitoring1,
				children: []
			}, {
				id: 2,
				label: '进口球机画面2',
				url: videoMonitoring2,
				children: []
			}, {
				id: 3,
				label: '二衬台车',
				url: videoMonitoring3,
				children: []
			}];

			const video = this.$refs.videoRef;
			if (!video) {
				console.log('未获取到视频元素');
				return;
			}

			// 2. 强制加载+静音（提高成功率）
			video.load();
			video.muted = true;

			// 3. 直接尝试播放
			video.play()
				.then(() => console.log('极简模式播放成功'))
				.catch(err => console.error('极简模式播放失败：', err));

		} else {
			that.getList();
		}
	},
	methods: {
		getList() {
			videoMonitoring(this.form).then(res => {
				if (res.data.code == 200) {
					res.data.data.forEach(DataItem => {
						DataItem.data.forEach(item => {
							this.treeData.push({
								id: item.id,
								label: item.deviceName,
								url: item.liveVideoPath,
								children: item.children || []
							})
						})
					});
				}
			})
		},
		// 父组件处理节点点击的方法（接收子组件传递的 node 数据）
		handleNodeClick(node) {
			let that = this;
			if (node.url) {
				if (targetDate(that.$cookies.get('updatelhTargetDate')) === true) {
					this.player = new EZUIKit.EZUIKitPlayer({
						id: "ezuikit-player",
						AppKey: '1996d45de71441fc9f3485161443edc4',
						url: node.url, //"ezopen://open.ys7.com/FW8966051/1.hd.live",
						accessToken: that.$cookies.get('updatelhAccessToken'),
						width: '1280', // 设置播放器宽度
						height: '680'  // 设置播放器高度
					})
				} else {
					this.getAccessToken().then((accessToken) => {
						if (accessToken) {
							this.player = new EZUIKit.EZUIKitPlayer({
								id: "ezuikit-player",
								AppKey: '1996d45de71441fc9f3485161443edc4',
								url: node.url, //"ezopen://open.ys7.com/FW8966051/1.hd.live",
								accessToken: accessToken,
								width: '1280', // 设置播放器宽度
								height: '680'  // 设置播放器高度
							})
						}
					});
				}
			}
		},
		async getAccessToken() {
			try {
				let that = this;
				// 替换为实际的获取 accessToken 接口地址
				const appKey = '1996d45de71441fc9f3485161443edc4';
				const appSecret = 'f61bdb711facd428ddf07c5fceb517e9';
				const url = `https://open.ys7.com/api/lapp/token/get?appKey=${appKey}&appSecret=${appSecret}`;
				const response = await axios.post(url);
				if (response.data.code === '200') {
					that.$cookies.set('updatelhAccessToken', response.data.data.accessToken);
					that.$cookies.set('updatelhTargetDate', response.data.data.expireTime);
					return response.data.data.accessToken;
				} else {
					console.error('获取 accessToken 失败:', response.data.msg);
					return null;
				}
			} catch (error) {
				console.error('请求 accessToken 时出错:', error);
				return null;
			}
		}
	},
	beforeDestroy() {

	}
}
</script>
<style scoped>
/* 引入字体 */
@font-face {
	font-family: 'DS-Digital';
	src: url('../font/DS-DIGIB.TTF') format('truetype');
	font-weight: normal;
	font-style: normal;
}

.cloud-videoMonitoring {
	width: 100%;
	height: 100%;
	text-align: left;


	>.cloud-videoMonitoring-l {
		position: relative;
		width: calc(400 / 1920 * 100vw);
		height: calc(920 / 1080 * 100vh);
		left: 1vw;
		top: 1vh;
		float: left;
		overflow: hidden;
		border-radius: 20px;
	}

	>.cloud-videoMonitoring-r {
		position: relative;
		width: calc(1470 / 1920 * 100vw);
		height: calc(920 / 1080 * 100vh);
		top: 1vh;
		margin-left: 1.8vw;
		float: left;
		overflow: hidden;
		border-radius: 20px;
	}



	.cloud-videoMonitoring-title {
		position: absolute;
		top: 1vh;
		left: 0;
		width: 100%;
		height: calc(920 / 1080 * 100vh);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 10px;

		.cloud-videoMonitoring-title-title {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 2.5vh;
			margin: 0;
			padding: 0;

			img {
				width: 100%;
				height: auto;
				margin: 0;
				padding: 0;
			}

			p {
				position: absolute;
				top: 0.3vh;
				left: 3.01vh;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;
			}
		}

		.cloud-videoMonitoring-title-content {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: calc(870 / 1080 * 100vh);
			margin: 0;
			padding: 0;
			overflow-y: auto;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
		}
	}


	.cloud-videoMonitoring-title-content-ul {
		list-style: none;
		margin: 0;
		padding: 0;
		margin-top: 3vh;

		>li {
			width: 25px;
			height: 25px;
			margin-right: 20px;
			margin-bottom: 20px;
			float: right;
			cursor: pointer;
			border: 1px dashed #4b4949;

			>img {
				width: 100%;
				height: 100%;
			}
		}
	}
}
</style>